import axios from "axios";

export const BASE_URL = "https://api.campfiresecurity.dk/v1/admin/"

const apiClient = axios.create({
  // Later read this URL from an environment variable
  baseURL: "https://api.campfiresecurity.dk/v1/admin"
});

export default apiClient;